module.exports = __webpack_public_path__ + "img/1.2a4968fc.jpg";